import { render } from "./Upgrading.vue?vue&type=template&id=0ec4d8de"
import script from "./Upgrading.vue?vue&type=script&lang=js"
export * from "./Upgrading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__